module.exports = __webpack_public_path__ + "static/media/x2000.de99c3b1.png";